// extracted by mini-css-extract-plugin
export default {"container":"Heading_container__3hoS-"};